import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import api from '../../api'
import Jobs from './customerjobs/Jobs'
import { useJobContext } from '../../context/JobContext'
import CustomerProducts from './products/CustomerProducts'
const Customer = () => {
  const param = useParams()
  const cust = param.id
  const [loading, setLoading] = useState(true);

 const {company, setCompany} = useJobContext()

  const [contacts, setContacts] = useState([
    { id: 1, name: 'John Doe', email: 'john@example.com', phone: '123-456-7890', role: 'Manager' },
    { id: 2, name: 'Jane Smith', email: 'jane@example.com', phone: '987-654-3210', role: 'Sales Lead' },
  ]);
  const [currentContact, setCurrentContact] = useState({ id: null, name: '', email: '', phone: '', role: '' });
  const [isEditing, setIsEditing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const getCustomer = async () => {
      try {
        setLoading(true);
        console.log('Fetching company data for ID:', cust);
        const response = await api.post('/company/getcompany', { id: cust });
        console.log('API response:', response.data);
        if (response.data.message) {
          setCompany(response.data.message)
        } else {
          // Handle no data case
        }
      } catch (err) {
        console.error('Error fetching company:', err);
      } finally {
        setLoading(false);
      }
    };

    if (cust) {
      getCustomer();
        
    }

  }, [cust]);

  const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    setCompany({ ...company, [name]: value });
  };

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setCurrentContact({ ...currentContact, [name]: value });
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    if (!currentContact.name || !currentContact.email || !currentContact.phone) return;

    if (isEditing) {
      setContacts(contacts.map(contact => 
        contact.id === currentContact.id ? currentContact : contact
      ));
      setIsEditing(false);
    } else {
      setContacts([...contacts, { ...currentContact, id: contacts.length + 1 }]);
    }
    setCurrentContact({ id: null, name: '', email: '', phone: '', role: '' });
    setIsModalOpen(false);
  };

  const handleEditContact = (contact) => {
    setCurrentContact(contact);
    setIsEditing(true);
    setIsModalOpen(true);
  };

  const handleDeleteContact = (id) => {
    setContacts(contacts.filter(contact => contact.id !== id));
  };

  const openAddContactModal = () => {
    setCurrentContact({ id: null, name: '', email: '', phone: '', role: '' });
    setIsEditing(false);
    setIsModalOpen(true);
  };

  const savecompanyinfo = () => {
    const newcompany = {
      name: company.name.trim(),
      dba: company.dba.trim()
    }
    console.log(newcompany)
  }

  if (loading) return <div className="container mx-auto p-6">Loading...</div>;

  console.log(company)
  return (
    <div className='relative w-full px-[30px]'>
    
      <div className="w-full p-2 text-3lg">
        <h1 className="text-[28px] font-bold text-gray-800 mb-2" style={{color:company.status ? 'inherit' :'rgb(255,0,0,.7)',fontWeight:company.status ? 'normal' :'bold' }}>  {company.name.trim()}</h1>
        <Tabs className=''>
          <TabList className="flex">
            <Tab>Info</Tab>
            <Tab>Jobs</Tab>
            <Tab>Mailing Info</Tab>
            <Tab>Products</Tab>
            <Tab>Promotions</Tab>
            <Tab>Seamless</Tab>
            <Tab>Printing</Tab>
            <Tab>Invoices</Tab>
          </TabList>
          <TabPanel>
            <div className="container mx-auto p-6 bg-gray-50 min-h-screen">
              <span style={{paddingRight:'20px'}}>Status:</span>
              <select
                type="dropdown"
                value={company.status}
                className='border rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-left py-1'
              >
                <option value="">Status Unknown</option>
                <option value='1'>Active</option>
                <option value='0'>Inactive</option>
              </select>

              {/* Company Information Section */}
              <div className="mb-10 p-6 bg-white rounded-lg shadow-lg">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Company Name</label>
                    <input
                      type="text"
                      name="name"
                      value={company.name}
                      onChange={handleCompanyChange}
                      className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="Enter company name"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">DBA</label>
                    <input
                      type="text"
                      name="dba"
                      value={company.dba}
                      onChange={handleCompanyChange}
                      className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="Enter DBA"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Industry</label>
                    <select
                      name="industry"
                      id="industry"
                      value={company.industry}
                      onChange={handleCompanyChange}
                      className='mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500'
                    >
                      <option value="">Select an Industry</option>
                      <option value="agriculture">Agriculture</option>
                      <option value="automotive">Automotive</option>
                      <option value="construction">Construction</option>
                      <option value="education">Education</option>
                      <option value="energy">Energy</option>
                      <option value="finance">Finance</option>
                      <option value="healthcare">Healthcare</option>
                      <option value="hospitality">Hospitality</option>
                      <option value="it">Information Technology</option>
                      <option value="manufacturing">Manufacturing</option>
                      <option value="retail">Retail</option>
                      <option value="telecommunications">Telecommunications</option>
                      <option value="transportation">Transportation</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="pt-5 block text-sm font-medium text-gray-600">Address</label>
                    <input
                      type="text"
                      name="address"
                      value={company.address}
                      onChange={handleCompanyChange}
                      className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="Enter address"
                    />
                  </div>
                  <div>
                    <label className="pt-5 block text-sm font-medium text-gray-600">Address 2</label>
                    <input
                      type="text"
                      name="address2"
                      value={company.address2}
                      onChange={handleCompanyChange}
                      className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="Enter address 2"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="pt-5 block text-sm font-medium text-gray-600">City</label>
                    <input
                      type="text"
                      name="city"
                      value={company.city}
                      onChange={handleCompanyChange}
                      className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="Enter city"
                    />
                  </div>
                  <div>
                    <label className="pt-5 block text-sm font-medium text-gray-600">State</label>
                    <input
                      type="text"
                      name="state"
                      value={company.state}
                      onChange={handleCompanyChange}
                      className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="Enter state"
                    />
                  </div>
                  <div>
                    <label className="pt-5 block text-sm font-medium text-gray-600">Zip Code</label>
                    <input
                      type="text"
                      name="zip"
                      value={company.zip}
                      onChange={handleCompanyChange}
                      className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="Enter zip code"
                    />
                  </div>
                </div>
                <div className='flex justify-end'>
                  <button
                    onClick={() => savecompanyinfo()}
                    className="mt-6 px-4 py-1 bg-[#2368D4] text-white rounded-md hover:bg-green-700 transition"
                  >
                    Save Company Info
                  </button>
                </div>
              </div>

              {/* Contacts Section */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="p-6 flex justify-between items-center">
                  <h2 className="text-xl font-semibold text-gray-700">Contacts</h2>
                  <button
                    onClick={openAddContactModal}
                    className="px-4 py-1 bg-[#2368D4] text-white rounded-md hover:bg-green-700 transition"
                  >
                    Add Contact
                  </button>
                </div>
                <table className="min-w-full">
                  <thead className="bg-[#2368D4] text-white">
                    <tr>
                      <th className="py-3 px-6 text-left text-sm font-semibold">Name</th>
                      <th className="py-3 px-6 text-left text-sm font-semibold">Email</th>
                      <th className="py-3 px-6 text-left text-sm font-semibold">Phone</th>
                      <th className="py-3 px-6 text-left text-sm font-semibold">Role</th>
                      <th className="py-3 px-6 text-left text-sm font-semibold">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contacts.map(contact => (
                      <tr key={contact.id} className="border-b hover:bg-gray-50">
                        <td className="py-4 px-6 text-gray-700">{contact.name}</td>
                        <td className="py-4 px-6 text-gray-700">{contact.email}</td>
                        <td className="py-4 px-6 text-gray-700">{contact.phone}</td>
                        <td className="py-4 px-6 text-gray-700">{contact.role}</td>
                        <td className="py-4 px-6 flex space-x-2">
                          <button
                            onClick={() => handleEditContact(contact)}
                            className="px-3 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDeleteContact(contact.id)}
                            className="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Contact Modal */}
              {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:'rgb(0,0,0,.7)'}}>
                  <div className="bg-white rounded-lg p-6 w-full max-w-md">
                    <h2 className="text-xl font-semibold text-gray-700 mb-4">
                      {isEditing ? 'Edit Contact' : 'Add New Contact'}
                    </h2>
                    <div className="grid grid-cols-1 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-600">Name</label>
                        <input
                          type="text"
                          name="name"
                          value={currentContact.name}
                          onChange={handleContactChange}
                          className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                          placeholder="Enter contact name"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-600">Email</label>
                        <input
                          type="email"
                          name="email"
                          value={currentContact.email}
                          onChange={handleContactChange}
                          className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                          placeholder="Enter contact email"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-600">Phone</label>
                        <input
                          type="tel"
                          name="phone"
                          value={currentContact.phone}
                          onChange={handleContactChange}
                          className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                          placeholder="Enter contact phone"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-600">Role</label>
                        <input
                          type="text"
                          name="role"
                          value={currentContact.role}
                          onChange={handleContactChange}
                          className="mt-1 p-2 w-full border rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                          placeholder="Enter contact role"
                        />
                      </div>
                    </div>
                    <div className="mt-6 flex space-x-3">
                      <button
                        onClick={handleContactSubmit}
                        className="px-4 py-1 bg-[#2368D4] text-white rounded-md hover:bg-green-700 transition"
                      >
                        {isEditing ? 'Update Contact' : 'Add Contact'}
                      </button>
                      <button
                        onClick={() => {
                          setCurrentContact({ id: null, name: '', email: '', phone: '', role: '' });
                          setIsEditing(false);
                          setIsModalOpen(false);
                        }}
                        className="px-4 py-1 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </TabPanel>
          <TabPanel><Jobs company={cust}/></TabPanel>
          <TabPanel>Mailing Info</TabPanel>
          <TabPanel><CustomerProducts company={cust} /> </TabPanel>
          <TabPanel>3</TabPanel>
          <TabPanel>4</TabPanel>
          <TabPanel>5</TabPanel>
          <TabPanel>6</TabPanel>
        </Tabs>
      </div>
    </div>
  )
}

export default Customer